<template>
  <b-container fluid>
    <b-row>
      <b-col lg="5">
        <iq-card class-name="iq-user-profile-block1">
          <template v-slot:body>
            <div class="user-details-block">
              <div class="user-profile text-center">
                <b-avatar size="150px" v-bind:src="
                  user.avatarUrl
                    ? user.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                "></b-avatar>
              </div>
              <div class="text-center mt-3">
                <h4>
                  <b>{{ user.name }} {{ user.lastname }}</b>
                </h4>
                <p>{{ user.country }}</p>
              </div>
            </div>
          </template>
        </iq-card>

          <!-- NEXT INTERACTIVE-->
          <iq-card v-if="organization.planInteractive">
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="far fa-eye"></i>
              Próximos eventos interactivos
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-dropdown no-caret size="lg p-0" toggle-class="text-decoration-none" variant="link">
              <template v-slot:button-content>
                <span id="dropdownMenuButtons" class="dropdown-toggle p-0" data-toggle="dropdown">
                </span>
              </template>
              <b-dropdown-item href="#">
                <i class="ri-eye-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.see") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-delete-bin-6-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.delete") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-pencil-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.edit") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-printer-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.print") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-file-download-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.download") }}
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template v-slot:body>
            <v-data-table :headers="headersInteractive" :hide-default-footer="true" :items="interactives" :search="search"
              disable-pagination>
              <template v-slot:item.visitType="{ item }">
                <div v-if="item.visitType" class="text-center cursor-point">
                  <i :style="'color: ' + item.visitType.colour" class="fas fa-circle mr-2"></i>{{ item.visitType.name }}
                </div>
              </template>
              <template v-slot:item.date="{ item }">
                <div v-if="item.startedAt">
                  {{ item.startedAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <b-button v-if="item.join" variant="success" @click="joinInteractive(item.id)">{{
                  $t("public.views.Pages.Professional.Dashboard.join")
                }}
                </b-button>
              </template>
            </v-data-table>
          </template>
        </iq-card>

        <!-- NEXT CITA-->
        <iq-card v-if="organization.planDashboardPicture" class="text-center mobile-hide">
          <template v-slot:body>
            <img :src="sapem" alt="sapem" class="sapem-img" />
          </template>
        </iq-card>
        <iq-card v-else>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="far fa-eye"></i>
              {{ $t("public.views.Pages.Professional.Dashboard.nextDates") }}
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-dropdown no-caret size="lg p-0" toggle-class="text-decoration-none" variant="link">
              <template v-slot:button-content>
                <span id="dropdownMenuButtons" class="dropdown-toggle p-0" data-toggle="dropdown">
                </span>
              </template>
              <b-dropdown-item href="#">
                <i class="ri-eye-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.see") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-delete-bin-6-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.delete") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-pencil-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.edit") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-printer-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.print") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-file-download-fill mr-2"></i>{{ $t("public.views.Pages.Professional.Dashboard.download") }}
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template v-slot:body>
            <v-data-table :headers="headers" :hide-default-footer="true" :items="appointments" :search="search"
              disable-pagination>
              <template v-slot:item.patients="{ item }">
                <div v-if="item.patients" class="text-center cursor-point">
                  <b-container v-if="item.patients.length > 1">
                    <GroupAvatar :avatars="getAvatarMultiUser(item.patients)" :max="4"></GroupAvatar>
                  </b-container>
                  <div v-else>
                    <div v-for="(patient, index) in item.patients" :key="index">
                      <UserInfo :user="patient"></UserInfo>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:item.visitType="{ item }">
                <div v-if="item.visitType" class="text-center cursor-point">
                  <i :style="'color: ' + item.visitType.colour" class="fas fa-circle mr-2"></i>{{ item.visitType.name }}
                </div>
              </template>
              <template v-slot:item.date="{ item }">
                <div v-if="item.startedAt">
                  {{ item.startedAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <b-button v-if="item.online && item.join" variant="success" @click="joinVideoconference(item.id)">{{
                  $t("public.views.Pages.Professional.Dashboard.join")
                }}
                </b-button>
              </template>
            </v-data-table>
          </template>
        </iq-card>
        <!--CALENDAR -->
      </b-col>
      <b-col lg="7">
        <div>
          <iq-card v-if="checkPermissionProfessional('MULTI_PROFESSIONAL', ['READ'])">
            <template v-slot:headerTitle>
              <h4 class="card-title title-typography-color">
                <i class="ri-search-line"></i>
                {{ $t("public.views.Pages.Professional.Dashboard.filter") }}
              </h4>
            </template>
            <template v-slot:headerAction>
              <slot name="headerAction">
                <b-button class="btn-xl" right variant="success" @click="goMySchedule">{{
                  $t("public.views.Pages.Professional.Dashboard.schedule")
                }}
                </b-button>
              </slot>
            </template>
            <template v-slot:body>
              <b-row>
                <b-col cols="12">
                  <b-form-group label-for="professionals">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Dashboard.professional"
                      )
                    }}:
                    </template>

                    <multiselect v-model="professionalsFilter" :clear-on-select="false" :close-on-select="false"
                      :multiple="false" :options="professionalsFilterSelect" :preselect-first="true"
                      :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="
                        $t(
                          'public.views.Pages.Professional.Dashboard.multiselect.deselectGroupLabel'
                        )
                      " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.placeholder2'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.selectedLabel'
  )
" @input="changeProfessionalsFilter">
                      <template slot="option" slot-scope="props">
                        <b-list-group-item class="d-flex align-items-center">
                          <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                          <span class="mr-auto title-typography-color">{{
                            props.option.text
                          }}</span>
                        </b-list-group-item>
                      </template>
                      <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span
                          class="option__desc"><span class="option__title">
                            <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                              class="mr-auto title-typography-color">{{
                                props.option.text
                              }}</span>
                          </span></span></template>
                      <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                          class="multiselect__single">{{ values.length }}
                          {{
                            $t(
                              "public.views.Pages.Professional.Dashboard.selectedProfessionals"
                            )
                          }}</span></template>
                    </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </div>
        <Schedule ref="schedule" :dashboard="true" :idProfessional="idProfessional"
          :professionalsSchedule="professionalsSchedule" :typeSchedule="typeSchedule"
          :visitTypeSchedule="visitTypeSchedule"></Schedule>
      </b-col>
    </b-row>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import Schedule from "../../../components/schedule/Schedule";
import UserInfo from "../../../components/account/UserInfo";
import IqCard from "../../../components/xray/cards/iq-card";
import { xray } from "../../../config/pluginInit";
import routes from "../../../router/index";

import sapem from "../../../assets/images/sapem.png";


import { mapActions, mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import "vue-group-avatar/dist/vue-group-avatar.css";
import { GroupAvatar } from "vue-group-avatar";

import avatarDefault from "../../../assets/images/user/user.jpg";

import userService from "../../../services/user";
import professionalService from "../../../services/professional";
import organizationService from "../../../services/organization";
import utilsService from "../../../services/utils";
import scheduleService from "../../../services/schedule";
import interactiveService from "../../../services/interactive";

export default {
  name: "Dashboard",
  computed: {
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  components: {
    IqCard,
    Schedule,
    multiselect: Multiselect,
    UserInfo,
    GroupAvatar,
  },

  mounted() {
    xray.index();
    this.getOrganization();
    if (this.$route.query.reload && this.$route.query.reload === true) {
      this.$router.push({
        name: "auth.professional.dashboard",
        query: { reload: false },
      });
      location.reload();
    }
    // Filter
    this.getAllProfessionals();
    this.getAllVisitType();
    // Next cita
    this.getNextEvents(5);
    this.pollingNextEvents = setInterval(
      () => this.getNextEvents(5),
      60000
    );

    this.getUser();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_DASHBOARD", info: "" });
  },
  methods: {
    async getOrganization() {
      let self = this;

      organizationService.get(localStorage.getItem("organizationId")).then(
        (response) => {
          if (response) {
            self.organization = response.data;

            if(self.organization.planInteractive){
              // Next interactive
              self.getNextInteractive(5);
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "getOrganization",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        },
        " "
      );
    },
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    getAvatarMultiUser(users) {
      let avatars = [];
      users.forEach(function (item) {
        if (item.avatar) {
          avatars.push(item.avatarUrl);
        } else {
          avatars.push(avatarDefault);
        }
      });

      return avatars;
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    triggerUnClickPopover() {
      this.popover = false;
    },
    triggerClickPopover() {
      this.popover = true;
    },
    goMySchedule() {
      this.professionalsSchedule = [];
      this.professionalsFilter = [];
      this.visitTypeSchedule = [];
      this.visitTypeFilter = [];
    },
    // Filter
    async getAllVisitType() {
      let self = this;

      scheduleService
        .getAllVisitTypeActive()
        .then((response) => {
          if (response) {
            self.visitTypeMap = new Map();

            let combo = [];
            response.data.forEach(function (item) {
              self.visitTypeMap.set(item.id, item);
              combo.push({
                colour: item.colour,
                value: item.id,
                text: item.name,
              });
            });
            self.visitTypeFilterSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "getAllVisitTypeActive",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        });
    },
    changeVisitTypesFilter() {
      this.visitTypeSchedule = [];
      this.professionalsSchedule = [];
      this.professionalsFilter = [];

      let self = this;

      if (
        this.visitTypeFilter &&
        this.visitTypeFilter.value &&
        this.visitTypeFilter.text &&
        this.visitTypeFilter.colour
      ) {
        let data = {
          id: this.visitTypeFilter.value,
          name: this.visitTypeFilter.text,
          color: this.visitTypeFilter.colour,
        };

        self.visitTypeSchedule.push(data);
      }
    },
    changeProfessionalsFilter() {
      this.visitTypeSchedule = [];
      this.professionalsSchedule = [];
      this.visitTypeFilter = [];

      let self = this;
      if (
        this.professionalsFilter &&
        this.professionalsFilter.value &&
        this.professionalsFilter.text
      ) {
        let data = {
          idProfessional: this.professionalsFilter.value,
          titleProfessional: this.professionalsFilter.text,
          fileProfessional: this.professionalsFilter.file,
          avatarUrl: this.professionalsFilter.avatar
            ? this.professionalsFilter.avatar +
            "/" +
            localStorage.getItem("authorization")
            : "",
        };

        self.professionalsSchedule.push(data);
      }
    },
    async getAllProfessionals() {
      let self = this;

      professionalService
        .getAllActive()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              uuid: item.uuid,
              value: item.id,
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              text: item.name + " " + item.lastname,
            };
            combo.push(data);
          });
          self.professionalsFilterSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllActive",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    checkDeviceAndRedirectMobileApp() {
      var is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent
      );
      var is_safari_or_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit/i.test(
        navigator.userAgent
      );

      if (is_uiwebview || is_safari_or_uiwebview) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }

      if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }

      if (navigator.userAgent.toLowerCase().indexOf("ipad") > -1) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }
      if (this.$device && this.$device.os_name && this.$device.os_name.name) {
        if (this.$device.os_name.name.includes("iOS")) {
          window.location.href =
            "https://apps.apple.com/us/app/cita-io/id1643449872";
        }
      }
    },
    joinInteractive(interactiveId) {
      routes.push({
                name: "auth.interactive.info",
                query: { interactiveId: interactiveId },
              });
    },
    joinVideoconference(eventId) {
      this.getEventJoinVideoconference(eventId);
    },
    getEventJoinVideoconference(eventId) {
      let self = this;
      utilsService.auditActivity({ action: "VIEW", module: "JOIN_EVENT", info: "" });
      //this.checkDeviceAndRedirectMobileApp();
      let href =
        process.env.VUE_APP_BASE_URL_WEBAPP + "auth/room?eventId="+ 
        eventId;
      window.open(href, "_blank");
    },
    async getUser() {
      let self = this;

      this.$awn.asyncBlock(
        userService.get(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.user = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        }
      );
    },
    async getNextEvents(number) {
      let self = this;

      scheduleService
        .getNextEvents(number)
        .then((response) => {
          if (response) {
            self.appointments = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getNextEvents",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              number: number
            })
          });
        });
    },
    async getNextInteractive(number) {
      let self = this;

      interactiveService
        .getNext(number)
        .then((response) => {
          if (response) {
            self.interactives = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getNextEvents",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              number: number
            })
          });
        });
  },
  },
  data() {
    return {
      sapem: sapem,
      organization: {},
      max: 2,
      popover: false,
      //Filter
      professionalsSchedule: [],
      professionalsFilterSelect: [],

      visitTypeSchedule: [],
      visitTypeFilterSelect: [],

      //Select Filter
      professionalsFilter: [],
      visitTypeFilter: [],

      user: {},
      file: "",
      defaultAvatar: true,
      // Next cita
      pollingNextEvents: null,

      search: "",
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Dashboard.headers.patients"
          ),
          value: "patients",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Dashboard.headers.visitType"
          ),
          value: "visitType",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Dashboard.headers.date"
          ),
          value: "date",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      headersInteractive: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Dashboard.headers.visitType"
          ),
          value: "visitType",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Dashboard.headers.date"
          ),
          value: "date",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      appointments: [],
      interactives: [],
      // Calendar
      typeSchedule: "PROFESSIONAL",
      idProfessional: localStorage.getItem("userId"),
    };
  },
  beforeDestroy() {
    clearInterval(this.pollingNextEvents);
  },
};
</script>
